import React from 'react';
import styled from '@emotion/styled';
import { RenderElementProps, useSelected, useSlateStatic } from 'slate-react';
import { CustomElement, InlineMarks } from '../../../../../slate';
import { Editor } from 'slate';
import { usePowerEditorContext } from '../../slate/PowerEditorContext';
import { EditFootnoteCommand } from './types';


const FootnoteWrapper = styled.span<{ isSelected?: boolean, formats?: InlineMarks }>`
  background: ${props => props.isSelected ? (props as any).theme.palette.primary.main : "#dddddd"};
  padding: 0.2em 0.15em;
  border-radius: 4px;
  font-weight: ${props => props.formats?.bold ? 600 : "normal"};
  font-style: ${props => props.formats?.italic ? "italic" : "normal"};
  text-decoration: ${props => props.formats?.underline ? "underline" : props.formats?.strikethrough ? "line-through"  : "normal"};

  vertical-align: super;
  font-size: smaller; 
  cursor: pointer;
`;

interface Props extends RenderElementProps {
  openEdit?: (editor: Editor, element: CustomElement) => void;
}

export const FootnoteElement = (props: Props) => {
  const isSelected = useSelected();
  const editor = useSlateStatic();
  const { invokeCommand } = usePowerEditorContext();

  return (
      <FootnoteWrapper
        {...props.attributes}
        title={(props.element as any).footnote_text}
        isSelected={isSelected}
        formats={(props.element as any).marks as InlineMarks}
        onClick={() => {
          invokeCommand(EditFootnoteCommand, editor, props.element);
            if(props.openEdit) {
                props.openEdit(editor, props.element);
            }
        }}
        >
        {props.children}{(props.element as any).label || "*"}
      </FootnoteWrapper>
    );
}
